export default __webpack_public_path__ + "static/text-gradient-background-compressed-874756964f10438c59fcd5249f3ee98b.jpeg";